export enum EligibilityPurposeType {
    AuthRequirement = 1,
    Benefit = 2,
    Discovery = 3,
    Validation = 4,
}
